import { container, pageHeader } from 'core/style';
import injectSheet, { createStyles } from 'core/style/injectSheet';
import { ITheme, WithStyles } from 'core/style/interfaces';
import React from 'react';
import { Link } from 'react-router-dom';
import SocialIcons from 'site/components/social-icons/SocialIcons';
import ContactsPreview from './ContactsPreview';

const routingPrefix = LOCAL_SETTINGS.GLOBAL_ROUTE_PREFIX || '';

const ContactsPage: React.StatelessComponent<WithStyles<typeof styles>> = ({ classes }) => (
    <>
        <div className={classes.header}>
            <h1>Контакты</h1>
        </div>
        <div className={classes.container}>
            <p>
                Если у вас есть вопросы по нашим курсам, сервисам или любому функционалу сайта, пожалуйста, свяжитесь с
                нами:
            </p>
            <div className={classes.contactsWrap}>
                <ContactsPreview showHead={false} contrast={false} email={HELP_EMAIL} phone={PHONE_1} />
            </div>

            <div itemScope itemType="http://schema.org/Organization">
                <meta itemProp="name" content="Школа Московской Биржи" />
                <div itemProp="address" itemScope itemType="http://schema.org/PostalAddress">
                    <meta itemProp="streetAddress" content="Воздвиженка, 4/7с1" />
                    <meta itemProp="postalCode" content="125009" />
                    <meta itemProp="addressLocality" content="Москва" />
                </div>
                <meta itemProp="telephone" content="8 (495) 363-32-32" />
                <meta itemProp="email" content="moex.school@moex.com" />
            </div>

            <p>
                На все вопросы отвечаем почти в любое время дня и ночи. Пишите и звоните, никого не оставим без ответа.
            </p>

            <p>
                По всем организационным и административным вопросам, с предложениями партнерства, сотрудничества и любым
                другим предложениям, пишите на почту{' '}
                <a target="blank" href={'mailto:' + CONTACT_EMAIL}>
                    {CONTACT_EMAIL}
                </a>
            </p>
            <p>
                <p className={classes.beforePhoneList}>
                    Другие наши номера, с которых наши сотрудники могут связываться с вами по телефону или через
                    мессенджеры:
                </p>
                <ul className={classes.phoneList}>
                    <li>
                        <a href="tel:+7 988 940-38-67">+7 988 940-38-67</a>
                    </li>
                    <li>
                        <a href="tel:+7 958 538-43-19">+7 958 538-43-19</a>
                    </li>
                    <li>
                        <a href="tel:+7 931 009-41-81">+7 931 009-41-81</a>
                    </li>
                </ul>
            </p>

            <div className={classes.linksWrap}>
                <Link to={`${routingPrefix}/page/requisites`}>Реквизиты</Link>
                <br />
                <Link to={`${routingPrefix}/page/requisites-ano-idpo-mfc/`}>
                    Реквизиты по оплате партнерских образовательных программ с АНО «ИДПО МФЦ»
                </Link>
                <br />
                <a href={`${routingPrefix}/offer.docx`}>Пользовательское соглашение</a>
                <br />
                <a href={`${routingPrefix}/personal.docx`}>Согласие на обработку персональных данных</a>
            </div>
            <div className={classes.socialIconsWrap}>
                <SocialIcons mode="light" />
            </div>
        </div>
    </>
);

const styles = (theme: ITheme) =>
    createStyles({
        container: {
            ...container(theme),
            paddingTop: 1 + 'rem',
        },
        header: {
            ...pageHeader(theme),
        },
        contactsWrap: {
            background: theme.colors.lightGray,
            padding: 1 + 'rem',
            marginBottom: 1.5 + 'rem',
            textDecoration: 'none',
        },
        linksWrap: {
            marginBottom: 1.5 + 'rem',
            '& a': {
                textDecoration: 'none',
            },
        },
        socialIconsWrap: {
            textAlign: 'center',
            marginBottom: 1.5 + 'rem',
        },
        socialIcons: {
            textAlign: 'center',
            background: '#000',

            '& svg': {
                fill: 'black !important',
            },
        },
        phoneList: {
            listStyle: 'none',
            padding: 10,
            margin: 0,
        },
        beforePhoneList: {
            margin: 0,
        },
    });

export default injectSheet(styles, 'ContactsPage')(ContactsPage);
